import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import { sendEvent } from './Config';
import Footer from './components/Footer';

const Step1 = function () {
    const navigate = useNavigate();
    const leadIdRef = useRef(localStorage.getItem("lead_id"));

    const handleFormSubmit = async (e) => {
        try {
            e.preventDefault();

            navigate('/onboarding/nif');
        } catch (e) {
            console.error(e.message);
        }
    }

    useEffect(() => {
        sendEvent(leadIdRef.current ?? false, "website-opened", true);
    }, []);

    return <>
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Simulação de crédito BPF</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>Veja se a sua empresa consegue obter um empréstimo do BPF com condições exclusivas em apenas alguns cliques.</h1>
                    <p className='mt-6 separator-bottom pb-8'>Com o apoio do BPF, a sua empresa pode obter financiamento com juros até 1,5% ao ano e prazos até 30 anos.</p>
                    <button type="submit" className='primary w-full mt-12'>Continuar</button>
                </div>
            </form>
        </div>
    </>
}

export default Step1;